import * as selectors from './selectors';
import * as actions from './actions';
export const cards = {
    actions,
    selectors,
};
